export default {
  hasChanges: state => state.changes.length > 0,
}
